export default __webpack_public_path__ + "static/media/section-four.b902e10b.jpg";